

import { WDFormBasic } from './wd-form-basic';
import WDApi from '../../core/fetch/wd-api.js';
import { WDProxyArray } from '../../core/wd-proxy.js';
import WDPillBoxProxy from '../pill/wd-pillbox-proxy';

export class WDFormPillselect extends WDFormBasic {

	#enabledList = null;
	#disabledList = null
	#enabledSort;
	#disabledSort;
	#values;
	#options;
	#fetch;
					
	constructor(opts)
	{
		if (!opts.templates) opts.templates = {label:'${label}', value:'${value}'};

		const elem = wdc('<div class="wd-form-pillselect-wrapper"/>');
		super(elem,opts);


		this.#fetch = opts.fetch;

		this.#values = opts?.value ? new WDProxyArray(opts.value) : new WDProxyArray([]);

		this.#options = opts.options ? new WDProxyArray(opts.options) : new WDProxyArray([]);
	};

	connectedCallback()
	{
		super.connectedCallback();

		this.inputGroup().replaceChildren();		
		this.buildLists();
		this.refresh();
	};

	disconnectedCallback()
	{
		super.disconnectedCallback();

		/*
		this.#enabledSort.destroy();
		this.#disabledSort.destroy();

		this.#enabledSort = null;
		this.#disabledSort = null;
		*/
	};

  fetch() { return this.#fetch; };
  setFetchURI(uri) { 
  	this.#fetch.setBaseURI(uri); 
  	this.refresh();
	};
  	
	val(val)
	{
		if (val === undefined)
		{
			return this.#values;
		}
		else
		{
			this.#values = val || new WDProxyArray([]);
			this.updateLists();
			return this;
		}
	};

	options()
	{
		return this.#options;
	};

	setOptions(opts)
	{
		this.#options.replace(opts);
		this.updateLists();		
	};

	optionsWithValues()
	{
		const output = [];

		console.log('Options With Values',this.#values);

		//load the options in order of the values		
		this.#values.forEach( value => {
			output.push( this.#options.find( opt => opt.value == value ) );
		});

		return output;
	};
	
	optionsWithoutValues()
	{
		return this.#options.filter( opt => !this.#values.includes(opt.value) );
	};

	/**
		* property methods for the template
		*/
	refresh()
	{
		this.#fetch.req().then( results => {
			this.setOptions(results);
		});
	};

	updateLists()
	{
		this.#enabledList.proxy().replace( this.optionsWithValues() );
		this.#disabledList.proxy().replace( this.optionsWithoutValues() );
	};

	buildLists()
	{
		this.#enabledList = new WDPillBoxProxy({
			method: 'post',
			template: this.config().templates,
			allow_sort: false,
		});

		this.#enabledList.prefix().append( wdc('<div class="wd-pillselect-header">Enabled</div>') );
		this.#enabledList.content().classList.add('wd-form-pillselect-enabled');
		this.inputGroup().append(this.#enabledList);

		/**
			* disabled fields
			*/
		this.#disabledList = new WDPillBoxProxy({
			method: 'post',
			template: this.config().templates,
			allow_sort: false,
		});

		this.#disabledList.prefix().append( wdc('<div class="wd-pillselect-header">Disabled</div>') );
		this.#disabledList.content().classList.add('wd-form-pillselect-disabled');
		this.inputGroup().append(this.#disabledList);
		this.setupSortable();
		//this.refresh();
	};

	setupSortable()
	{ 
		import('sortablejs').then( module => {

			const Sortable = module.default;

			this.#enabledSort = Sortable.create( this.#enabledList.content(), {
														group: 'scopeList',
														draggable: '.btn',
														animation: 150,
														fallbackOnBody: true,
														swapThreshold: 0.65,
														onEnd: (evt) => this.handleSortEnd(evt),
													});

			this.#disabledSort = Sortable.create( this.#disabledList.content(), {
														group: 'scopeList',
														draggable: '.btn',
														animation: 150,
														fallbackOnBody: true,
														swapThreshold: 0.65,
														onEnd: (evt) => this.handleSortEnd(evt),
													});
		});	 
	};	

	handleSortEnd(evt)
	{
		//get reference to the original item
		const itemData = evt.item.data();
		const isEnabled = evt.to.classList.contains('wd-form-pillselect-enabled');

		if (isEnabled)
		{
			//reordering within
			if (evt.from == evt.to)
			{
				this.#values.reorder(evt.oldIndex,evt.newIndex);
			}
			//moving from disabled to enabled
			else
			{
				const value = this.config().templates.value.interpolate(itemData);
				this.#values.insert(evt.newIndex,value);
			}

		}
		else
		{
			//disabling
			const value = this.config().templates.value.interpolate(itemData);
			this.#values.remove( this.#values.indexOf(value) );
		}

		this.trigger('change');
		this.updateLists();
	};


	/*
	readonly(val)
	{
		//return this._dropdown.readonly(val);
	};


  validate()
  {
    let ret = true;

    console.log('Validate',this.config().required,this.val());

    //if set to not allow nulls   
    if (this.config().required == true && this.val() == null)
    {
      console.log('mark error');
      ret = false;
      this.markError();
    }
    else 
    {
      console.log('mark success');
      ret = true;
      this.markSuccess();
    }
    return ret;
  };
  */
};

customElements.define('wd-form-pillselect',WDFormPillselect);


